import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEqual } from 'lodash';

import log from "Utils/logger";

import * as RoundUpsTransactionsActions from 'Flux/transactions-round-ups/actions';

const useFetchPayments = () => {
  console.log ("*** ** fetchPayments: hook triggered");
  //based on chatgpt feedback need to look to remove some of the Refs being used to control updates.
  const isFetchingPaymentsRef = useRef(false);
  const hasFetchedPaymentsRef = useRef(false);
  const updatingPaymentDataOnContributeNowTransactionsRef = useRef(false);
  const hasUpdatedPaymentDataOnContributeNowTransactionsRef = useRef(false);
  const updatingPaymentDataOnRoundUpsTransactionsRef = useRef(false);
  const hasUpdatedPaymentDataOnRoundUpsTransactionsRef = useRef(false);
  const debounceTimerRef = useRef(null);

  const dispatch = useDispatch();
  //const roundups = useSelector(state => state.roundups);
  
  const storedContributeNowTransactions = useSelector(state => state.roundUpsTransactions.contributeNowTransactions);
  const storedPayments = useSelector(state => state.roundUpsTransactions.payments);
  const storedRoundUpsTransactions = useSelector(state => state.roundUpsTransactions.roundUpsTransactions);

  const storedContributeNowTotalClearing = useSelector(state => state.roundUpsTransactions.contributeNowTotalClearing);
  const storedContributeNowTotalCleared = useSelector(state => state.roundUpsTransactions.contributeNowTotalCleared);
  const storedContributeNowTotalReceived = useSelector(state => state.roundUpsTransactions.contributeNowTotalReceived);
  const storedContributeNowTotalPaid = useSelector(state => state.roundUpsTransactions.contributeNowTotalPaid);

  const storedRoundUpsTotalClearing = useSelector(state => state.roundUpsTransactions.roundUpsTotalClearing);
  const storedRoundUpsTotalCleared = useSelector(state => state.roundUpsTransactions.roundUpsTotalCleared);
  const storedRoundUpsTotalReceived = useSelector(state => state.roundUpsTransactions.roundUpsTotalReceived);
  const storedRoundUpsTotalPaid = useSelector(state => state.roundUpsTransactions.roundUpsTotalPaid);
  
  const user = useSelector(state => state.authentication.user);
  const roundUpsOnBoardingCompleted  = useSelector(state => state.roundups.roundUpsOnBoardingCompleted);
  
  const fetchPayments = async () => {
    isFetchingPaymentsRef.current = true;
    try {
      // if (!storedPayments || !storedPayments.length || !user) {
      //   console.log('*** ** fetchPayments: exit function as no storedPayments or no user');
      //   isFetchingPaymentsRef.current = false;
      //   return;
      // }
      const result = await dispatch(RoundUpsTransactionsActions.fetchPayments());
      //const newPayments = result.data.data;

     console.log('*** ** fetchPayments: result: ', result);

     const newPayments = result.data.data;
     
      console.log('*** ** fetchPayments: storedPayments: ', storedPayments)
      console.log ('*** ** fetchPayments: newPayments: ', newPayments);
      
      //console.log('*** ** fetchPayments: JSON.stringify(storedFavouriteShops): ', JSON.stringify(storedPayments));
      //console.log ('*** ** fetchPayments: JSON.stringify(newPayments): ', JSON.stringify(newPayments));

      //console.log(['isFetchingPaymentsRef status: ' , this.({isFetchingPaymentsRef})]);
      
      if (shouldUpdateStore(newPayments, storedPayments)) {
        console.log('*** ** fetchPayments: DIFFERENCE - should update store');
        dispatch(RoundUpsTransactionsActions.setPayments(result.data.data));
      }
    

    } catch (exception) {
      console.log(exception);
      log({
        event: "System-Error",
        source: "Fetch Payments",
        info: exception,
        ...exception,
      });
    } finally {
      isFetchingPaymentsRef.current = false;
      hasFetchedPaymentsRef.current = true;
    }
  };

  function shouldUpdateStore(newPayments, storedPayments) {

    if (!isEqual(newPayments, storedPayments)) {
      return true;
    } 
    return false;
  }

  useEffect(() => {
    console.log('*** ** fetchPayments: useEffect triggered with user:', user);
    console.log('*** ** fetchPayments: useEffect triggered with roundUpsOnBoardingCompleted:', roundUpsOnBoardingCompleted);
    console.log('*** ** fetchPayments: useEffect triggered with storedPayments:', storedPayments);
    console.log('*** ** fetchPayments: useEffect triggered with storedContributeNowTransactions:', storedContributeNowTransactions);
    console.log('*** ** fetchPayments: useEffect triggered with storedRoundUpsTransactions:', storedRoundUpsTransactions);
    console.log('*** ** fetchPayments: useEffect triggered with isFetchingPaymentsRef:', isFetchingPaymentsRef.current);
    console.log('*** ** fetchPayments: useEffect triggered with hasFetchedPaymentsRef:', hasFetchedPaymentsRef.current);

    if ( user
        && roundUpsOnBoardingCompleted
        && !isFetchingPaymentsRef.current
        && !hasFetchedPaymentsRef.current) {
      fetchPayments();
    }
  }, [roundUpsOnBoardingCompleted]);


  useEffect(() => {
    console.log('*** ** fetchPayments: useEffect trigerred by update to storedPayments:', storedPayments);
    console.log('*** ** fetchPayments: useEffect trigerred by update to storedPayments with storedPayments.length:', storedPayments ? storedPayments.length : 'no storedPayments'); 
    console.log('*** ** fetchPayments: useEffect trigerred by update to storedPayments with isFetchingPaymentsRef:', isFetchingPaymentsRef.current)
    console.log('*** ** fetchPayments: useEffect trigerred by update to storedPayments with hasFetchedPaymentsRef:', hasFetchedPaymentsRef.current)
    console.log('*** ** fetchPayments: useEffect trigerred by update to storedPayments with storedContributeNowTransactions:', storedContributeNowTransactions);
    console.log('*** ** fetchPayments: useEffect trigerred by update to storedPayments with updatingPaymentDataOnContributeNowTransactionsRef:', updatingPaymentDataOnContributeNowTransactionsRef.current);
    //Testing the following without useRefs based on chatgpt feedback.
    //Now returning the refs
    if (!Array.isArray(storedPayments) || storedPayments.length === 0) return;
    //updateContributeNowTransactions();
    //setPaymentDataOnRoundUpsTransactions();
    if (!updatingPaymentDataOnContributeNowTransactionsRef.current){
         updateContributeNowTransactions();
    }
    if (!updatingPaymentDataOnRoundUpsTransactionsRef.current){ 
      setPaymentDataOnRoundUpsTransactions();
    }
    console.log('*** ** fetchPayments: useEffect trigerred by update to storedPayments is now going to updateContributeNowTransactions and setPaymentDataOnRoundUpsTransactions as hasFetchedPaymentsRef.current is true and storedPayments is not empty');

    //if (Array.isArray(storedPayments) && storedPayments.length > 0){
        //storedPayments 
        //&& storedPayments.length
        //&& hasFetchedPaymentsRef.current) {
         // if (!updatingPaymentDataOnContributeNowTransactionsRef.current){
          //   updateContributeNowTransactions();
          // }
          // if (!updatingPaymentDataOnRoundUpsTransactionsRef.current){ 
          //   setPaymentDataOnRoundUpsTransactions();
          // }
       // }
  }, [storedPayments]);

  useEffect(() => {
    console.log('*** ** fetchPayments: useEffect triggered by update to storedRoundUpsTransactions:', storedRoundUpsTransactions);
    if (!hasFetchedPaymentsRef.current
      && !isFetchingPaymentsRef.current ) {
        fetchPayments();
    } else if (storedPayments 
        && storedPayments.length
        && hasFetchedPaymentsRef.current) {
          if (!updatingPaymentDataOnRoundUpsTransactionsRef.current){ 
            setPaymentDataOnRoundUpsTransactions();
          }
    }
  }, [storedRoundUpsTransactions]);





/*   useEffect(() => {
    console.log('*** ** fetchPayments: useEffect hasFetchedPaymentsRef.current:', hasFetchedPaymentsRef.current);
    if (storedPayments 
        && storedPayments.length
        && hasFetchedPaymentsRef.current) {
          if (!updatingPaymentDataOnContributeNowTransactionsRef.current){
            updateContributeNowTransactions();
          }
          if (!updatingPaymentDataOnRoundUpsTransactionsRef.current){ 
            setPaymentDataOnRoundUpsTransactions();
          }
        }
  }, [hasFetchedPaymentsRef.current]); */


  

  useEffect(() => {
    if (storedContributeNowTransactions && storedContributeNowTransactions.length > 0) {
      updateContributeNowTotals();
    }
  }, [storedContributeNowTransactions]);

  useEffect(() => {
    if (storedRoundUpsTransactions && storedRoundUpsTransactions.length > 0) {
      updateRoundUpsTotals();
    }
  }, [storedRoundUpsTransactions]);

  const updateContributeNowTransactions = async () => {
    updatingPaymentDataOnContributeNowTransactionsRef.current = true;
    try {
      
      console.log('*** ** fetchPayments: updateContributeNowTransactions triggered with storedContributeNowTransactions:', storedContributeNowTransactions);
      //const updatedContributeNowTransactions = storedPayments.filter(payment => payment.paymentData.payout.description.includes('Fixed'));
      //const updatedContributeNowTransactions = storedPayments.filter(payment => payment.description.includes('Fixed'));
      const updatedContributeNowTransactions = storedPayments.filter(payment =>
        payment.description?.includes('Fixed') ||
        payment.description?.toLowerCase().includes('contributenow')
        //!Array.isArray(payment.transactions) ||  // think we can remove these last 2 lines afer testing
        //payment.transactions.length === 0
      );

      console.log('*** ** fetchPayments: updateContributeNowTransactions - updatedContributeNowTransactions extracted from storedPayments:', updatedContributeNowTransactions);


      console.log('*** ** fetchPayments: updateContributeNowTransactions triggered with roundUpsTransactions.storedContributeNowTransactions:', storedContributeNowTransactions);
      if (!isEqual(updatedContributeNowTransactions,storedContributeNowTransactions) ) { 
        console.log('*** ** fetchPayments: DISPATCH - PURCHASES SET CONTRIBUTENOW TRANSACTIONS with updatedContributeNowTransactions:', updatedContributeNowTransactions);
        await  dispatch(RoundUpsTransactionsActions.setContributeNowTransactions(updatedContributeNowTransactions))
      }
    } catch(exception) {
      console.log(exception);
      log({
        event: "System-Error",
        source: "*** ** fetchPayments: Updating Contribute Now Transactions with Payment Data",
        //'shopper_id': authentication? authentication.user.shopper_id : '000',
        info: JSON.stringify(exception),
        ...exception,
      });
    } finally {
      updatingPaymentDataOnContributeNowTransactionsRef.current = false;
    }
  };

  const updateContributeNowTotals = async () => {
    console.log('*** ** fetchPayments: updateContributeNowTotals has commenced with storedContributeNowTransactions:', storedContributeNowTransactions)
    let totalClearing = 0;
    let totalCleared = 0;
    let totalReceived = 0;
    let totalPaid = 0;
  
    storedContributeNowTransactions.forEach(payment => {
      if (payment &&
          (  payment.description.includes('Fixed')
          || payment.description?.toLowerCase().includes('contributenow'))) {
            if (payment.remittance?.paid === true) {
              totalPaid += payment.total_debit_amount;
            } else if (payment.status === 'approved' || 
                payment.status === 'maturing' || 
                !payment.status) {
              totalClearing += payment.total_debit_amount;
            } else if (payment.status === 'cleared') {
              totalCleared += payment.total_debit_amount;
            }
          }
    });
  
      console.log('Total Clearing:', totalClearing);
      console.log('Total Cleared:', totalCleared);
      console.log('Total Received:', totalReceived);
      console.log('Total Paid:', totalPaid);
      if (totalClearing !== storedContributeNowTotalClearing ||
          totalCleared !== storedContributeNowTotalCleared ||
          totalReceived !== storedContributeNowTotalReceived ||
          totalPaid !== storedContributeNowTotalPaid) {
        console.log('DISPATCH - PURCHASES SET PAYMENTS TOTALS with totalClearing:', totalClearing, 'totalCleared:', totalCleared, 'totalReceived:', totalReceived, 'totalPaid:', totalPaid)
        dispatch(RoundUpsTransactionsActions.setPaymentsTotals(totalClearing, totalCleared, totalReceived, totalPaid));
      }
    };

    const updateRoundUpsTotals = async () => {
      console.log('*** ** fetchPayments: updateROundUpsTotals has commenced with storedRoundUpsTransactions: ', storedRoundUpsTransactions);
      let totalClearing = 0;
      let totalCleared = 0;
      let totalReceived = 0;
      let totalPaid = 0;
  
      storedRoundUpsTransactions.forEach(roundUp => {
        if (roundUp
            && roundUp.debit_amount_cents
        ) {
          console.log('forEach roundUp.status:', roundUp.status)
          console.log('forEach roundUp.debit_amount_cents:', roundUp.debit_amount_cents)
          if (roundUp.status === 'approved' || roundUp.status === 'maturing' || !roundUp.status) {
            totalClearing += roundUp.debit_amount_cents;
          } else if (roundUp.remittance?.paid === true) {
            totalPaid += roundUp.paid_amount_cents;
          } else if ((roundUp.status === 'posted' || roundUp.status === 'cleared') && roundUp.paid_amount_cents ) {
            totalCleared += roundUp.paid_amount_cents;
          } else if (roundUp.status === 'BYS received') {
            totalReceived += roundUp.debit_amount_cents;
          }
        }
      });
      if (totalClearing !== storedRoundUpsTotalClearing ||
          totalCleared !== storedRoundUpsTotalCleared ||
          totalReceived !== storedRoundUpsTotalReceived ||
          totalPaid !== storedRoundUpsTotalPaid) 
          { 
              console.log('DISPATCH - PURCHASES SET ROUNDUPS TOTALS with totalClearing:', totalClearing, 'totalCleared:', totalCleared, 'totalReceived:', totalReceived, 'totalPaid:', totalPaid)   
              dispatch(RoundUpsTransactionsActions.setRoundUpsTotals(totalClearing, totalCleared, totalReceived, totalPaid));
          }
    };



    const setPaymentDataOnRoundUpsTransactions = async () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    
      debounceTimerRef.current = setTimeout(async () => {
        if (!Array.isArray(storedRoundUpsTransactions) || storedRoundUpsTransactions.length === 0) {
          console.log('*** ** fetchPayments: storedRoundUpsTransactions not ready yet, skipping update.');
          updatingPaymentDataOnRoundUpsTransactionsRef.current = false;
          return;
        }
    
        if (!Array.isArray(storedPayments) || storedPayments.length === 0) {
          console.log('*** ** fetchPayments: storedPayments not ready yet, skipping update.');
          updatingPaymentDataOnRoundUpsTransactionsRef.current = false;
          return;
        }
    
        updatingPaymentDataOnRoundUpsTransactionsRef.current = true;
        console.log('*** ** fetchPayments: *** setPaymentDataOnRoundUpsTransactions triggered with roundUpsTransactions:', storedRoundUpsTransactions);
    
        let updatedRoundUpsTransactions = storedRoundUpsTransactions.map(t => ({ ...t }));
    
        try {

          updatedRoundUpsTransactions = updatedRoundUpsTransactions.map(transaction => {
            const matchingPayment = storedPayments.find(payment =>
              payment?.description?.includes('Roundup') &&
              Array.isArray(payment.transactions) &&
              payment.transactions.some(pt => pt.remote_id === transaction.remote_id)
            );

            if (!matchingPayment) {
              console.log('*** ** fetchPayments: *** No matching payment found for transaction:', transaction.remote_id);
              return transaction;
            }

            return {
              ...transaction,
              status: matchingPayment.status,
              withdrawalDate: matchingPayment.created_at,
              party_bank_ref: matchingPayment.party_bank_reference,
              remittance: matchingPayment.remittance,
            };
          });
    
          console.log('*** ** fetchPayments: Updated round ups transactions:', updatedRoundUpsTransactions);
          console.log('*** ** fetchPayments: storedRoundUpsTransactions:', storedRoundUpsTransactions);
    
          if (shouldUpdate(updatedRoundUpsTransactions, storedRoundUpsTransactions)) {
            console.log('*** ** fetchPayments: DISPATCH - PURCHASES SET ROUNDUPS TRANSACTIONS with updatedRoundUpsTransactions:', updatedRoundUpsTransactions);
            await dispatch(RoundUpsTransactionsActions.setRoundUpsTransactions(updatedRoundUpsTransactions));
          }
        } catch (exception) {
          console.error('Error occurred during processing:', exception);
          log({
            event: "System-Error",
            source: "*** setPaymentDataOnRoundUps",
            info: JSON.stringify(exception),
            ...exception,
          });
        } finally {
          updatingPaymentDataOnRoundUpsTransactionsRef.current = false;
        }
      }, 300); // 300ms debounce
    };

    const shouldUpdate = (updated, original) => {
      return updated.some((t, i) => {
        const o = original[i];
        return (
          t.status !== o.status ||
          t.withdrawalDate !== o.withdrawalDate ||
          t.party_bank_ref !== o.party_bank_ref ||
          JSON.stringify(t.remittance) !== JSON.stringify(o.remittance)
        );
      });
    };

  return { 
          isFetchingPayments: isFetchingPaymentsRef.current,
          // hasFetchedPayments: hasFetchedPaymentsRef.current,
           fetchPayments };

};

export default useFetchPayments;





